// extracted by mini-css-extract-plugin
export default {"status-text":"kvpR6vilKyEwvEuZGZDD","divider":"PsVdLmzE7FtlAGw7G7gn","copy-purl":"IS0RD3USWR2Gf4nAEPog"};